// extracted by mini-css-extract-plugin
export default {"header":"xpluj23A1sUrebDYeqam","image":"_xmlGfWS8NE1LnUr4NQg","tableContainer":"Eh5K694JE1JWZ_vq1yZ7","tablePrint":"UsVi6b6r3mxUoi3JoHl7","clampedContainer":"sZmns3z3y4gfcTqCIFJ2"};